import '../css/mk-brand.css';
import React, {useState, useEffect, useMemo} from 'react';
import {
  WalletModalProvider,
  WalletDisconnectButton,
  WalletMultiButton,
} from '@solana/wallet-adapter-react-ui';
import {HashLink as Link} from 'react-router-hash-link';
import Hamburger from 'hamburger-react';
import twitterLogo from '../media/twitter-logo.png';
import instagramLogo from '../media/instagram-logo3.png';
import discordLogo from '../media/discord-logo2.png';
import logo from './../media/mk-logo.png'
import {useWallet} from '@solana/wallet-adapter-react';
import config from '../config';


function TWNavbar() {
  useEffect(() => {},);

  const [isOpen, setOpen] = useState(false);
  const matchResult = window.location.hash.match(/#\/(.*?)\//);
  const hash =  matchResult && matchResult[1] && matchResult[1].length > 0 ? matchResult[1] : 'home';

  const [page, setPage] = useState(hash);
  const { publicKey, wallet, disconnect } = useWallet();
  const base58 = useMemo(() => publicKey?.toBase58(), [publicKey]);

  const onPageChanged = e => {
    setPage(e);
    onToggleHamburgerMenu(false);
  }
  const getPageStyle = e => {
    if (e === page) {
      return ''; // don't add the hidden style.
    }
    return 'hidden';
  }
  const resetHamburgerMenu = () => {
    setPage('home');
    document.getElementById('hamburgerMenu').classList.add('hidden');
    setOpen(false);
  }
  const onToggleHamburgerMenu = toggled => {
    if (toggled) {
      // open a menu
      document.getElementById('hamburgerMenu').classList.remove('hidden');
    } else {
      // close a menu
      document.getElementById('hamburgerMenu').classList.toggle('hidden');
    }
    setOpen(toggled);
  }
  const onShow = e => {
    document.getElementById(e + '-menu')?.classList?.remove('hidden');
    document.getElementById(e + '-menu-bar')?.classList?.remove('hidden');
  }
  const onHide = e => {
    document.getElementById(e + '-menu')?.classList?.toggle('hidden');

    if (e !== page) {
      // hide the underline if this is not the active page.
      document.getElementById(e + '-menu-bar')?.classList?.toggle('hidden');
    }
  }
  const homeMenu = <div className="relative sticky shadow-white">
    <button
      onMouseEnter={() => onShow('home')}
      onMouseLeave={() => onHide('home')}
      className="text-xl text-brand-text cursor-pointer px-2 py-1"
    ><Link className="no-underline text-brand-text hover:text-brand-text" to="/home/" onClick={() => onPageChanged('home')}>Home</Link>
      <div id="home-menu" className="p-0 rounded absolute left min-w-3x1 bg-zinc-500 flex-col hidden top-9 left-0">
        <div className="hover:bg-brand-hover p-0 text-left"><Link to="/home/" className="p-2 text-brand-text no-underline hover:text-brand-text"
                                                                  onClick={() => onPageChanged('home')}>About Us</Link></div>
        <div className="hover:bg-brand-hover p-0 text-left"><Link to="/home/#roadmap-panel" className="p-2 text-brand-text no-underline hover:text-brand-text"
                                                                  onClick={() => onPageChanged('home')}>Roadmap</Link></div>
      </div>
      <div id="home-menu-bar" className={'h-0.5 bg-brand ' + getPageStyle('home')}/>
    </button>
  </div>;
  const gameMenu = <div className="relative sticky shadow-white">
    <button
      onMouseEnter={() => onShow('game')}
      onMouseLeave={() => onHide('game')}
      className="text-xl text-brand-text cursor-pointer px-2 py-1"
    ><Link className="no-underline text-brand-text hover:text-brand-text" to="/game/" onClick={() => onPageChanged('game')}>Game</Link>
      <div id="game-menu" className="p-0 rounded absolute left w-48 -z-2 bg-zinc-500 flex-col hidden top-9 left-0">
        <div className="hover:bg-brand-hover p-0 text-left"><Link to="/game/#super-og-info" className="p-2 text-brand-text no-underline hover:text-brand-text"
                                                                  onClick={() => onPageChanged('game')}><span className="text-brand font-extrabold">Super</span><b>OG</b></Link></div>
        <div className="hover:bg-brand-hover p-0 text-left"><Link to="/game/#ready-set-whip" className="p-2 text-brand-text no-underline hover:text-brand-text"
                                                                  onClick={() => onPageChanged('game')}>Ready, Set, Whip</Link></div>
        <div className="hover:bg-brand-hover p-0 text-left"><Link to="/game/#culinary-missions" className="p-2 text-brand-text no-underline hover:text-brand-text"
                                                                  onClick={() => onPageChanged('game')}>Culinary Missions</Link></div>
        <div className="hover:bg-brand-hover p-0 text-left"><Link to="/game/#mk-battle-school" className="p-2 text-brand-text no-underline hover:text-brand-text"
                                                                  onClick={() => onPageChanged('game')}><span className="font-extrabold">mK<span className="text-brand">Battle</span></span> School</Link></div>
        <div className="hover:bg-brand-hover p-0 text-left"><Link to="/game/#mk-battle-kitchen" className="p-2 text-brand-text no-underline hover:text-brand-text"
                                                                  onClick={() => onPageChanged('game')}><span className="font-extrabold">mK<span className="text-brand">Battle</span></span> Kitchen</Link></div>
      </div>
      <div id="game-menu-bar" className={'h-0.5 bg-brand ' + getPageStyle('game')}/>
    </button>
  </div>;
  const collectionsMenu = <div className="relative sticky shadow-white">
    <button
      onMouseEnter={() => onShow('collections')}
      onMouseLeave={() => onHide('collections')}
      className="text-xl text-brand-text cursor-pointer px-2 py-1"
    ><Link className="no-underline text-brand-text hover:text-brand-text" to="/collections/" onClick={() => onPageChanged('collections')}>Collections</Link>
      <div id="collections-menu" className="p-0 rounded absolute left w-40 -z-2 bg-zinc-500 flex-col hidden top-9 left-0">
        <div className="hover:bg-brand-hover p-0 text-left"><Link to="/collections/#og-chefs-panel" className="p-2 text-brand-text no-underline hover:text-brand-text"
                                                                  onClick={() => onPageChanged('collections')}>OG Chef</Link></div>
        <div className="hover:bg-brand-hover p-0 text-left"><Link to="/collections/#chef-coin-collections" className="p-2 text-brand-text no-underline hover:text-brand-text"
                                                                  onClick={() => onPageChanged('collections')}>$CHEF Coin</Link></div>
        <div className="hover:bg-brand-hover p-0 text-left"><Link to="/collections/#meta-chefs-panel" className="p-2 text-brand-text no-underline hover:text-brand-text"
                                                                  onClick={() => onPageChanged('collections')}>metaChef</Link></div>
      </div>
      <div id="collections-menu-bar" className={'h-0.5 bg-brand ' + getPageStyle('collections')}/>
    </button>
  </div>;
  const teamMenu = <div className="relative sticky shadow-white">
    <button
      onMouseEnter={() => onShow('team')}
      onMouseLeave={() => onHide('team')}
      className="text-xl text-brand-text cursor-pointer px-2 py-1"
    ><Link className="no-underline text-brand-text hover:text-brand-text" to="/team/" onClick={() => onPageChanged('team')}>Team</Link>
      <div id="team-menu" className="p-0 rounded absolute left w-40 -z-2 bg-zinc-500 flex-col hidden top-9 left-0">
        <div className="hover:bg-brand-hover p-0 text-left"><Link to="/team/#featured-chef" className="p-2 text-brand-text no-underline hover:text-brand-text"
                                                                  onClick={() => onPageChanged('team')}>Featured Chef</Link></div>
        <div className="hover:bg-brand-hover p-0 text-left"><Link to="/team/#our-team-panel" className="p-2 text-brand-text no-underline hover:text-brand-text"
                                                                  onClick={() => onPageChanged('team')}>Our Team</Link></div>
        <div className="hover:bg-brand-hover p-0 text-left"><Link to="/team/#join-us-panel" className="p-2 text-brand-text no-underline hover:text-brand-text"
                                                                  onClick={() => onPageChanged('team')}>Join Us</Link></div>
      </div>
      <div id="team-menu-bar" className={'h-0.5 bg-brand ' + getPageStyle('team')}/>
    </button>
  </div>;
  const papersMenu = <div className="relative sticky shadow-white">
    <button
      onMouseEnter={() => onShow('papers')}
      onMouseLeave={() => onHide('papers')}
      className="text-xl text-brand-text cursor-pointer px-2 py-1"
    ><Link className="no-underline text-brand-text hover:text-brand-text" to="/papers/" onClick={() => onPageChanged('papers')}>Papers</Link>
      <div id="papers-menu" className="p-0 rounded absolute left w-40 -z-2 bg-zinc-500 flex-col hidden top-9 left-0">
        <div className="hover:bg-brand-hover p-0 text-left "><Link to="/papers/" className="p-2 text-brand-text no-underline hover:text-brand-text "
                                                                  onClick={() => onPageChanged('papers')}>White Paper</Link></div>
        <div className="hover:bg-brand-hover p-0 text-left"><Link to="/papers/#papers-FAQ-panel" className="p-2 text-brand-text no-underline hover:text-brand-text"
                                                                  onClick={() => onPageChanged('papers')}>FAQ</Link></div>
        <div className="hover:bg-brand-hover p-0 text-left"><Link to="/papers/#partners" className="p-2 text-brand-text no-underline hover:text-brand-text"
                                                                  onClick={() => onPageChanged('papers')}>Partners</Link></div>
        <div className="hover:bg-brand-hover p-0 text-left"><Link to="/papers/#features-and-marketplaces" className="p-2 text-brand-text no-underline hover:text-brand-text"
                                                                  onClick={() => onPageChanged('papers')}>Marketplaces</Link></div>
      </div>
      <div id="papers-menu-bar" className={'h-0.5 bg-brand ' + getPageStyle('papers')}/>
    </button>
  </div>;
  const kitchenMenu = <div className="relative sticky shadow-white">
    <button
      onMouseEnter={() => onShow('kitchen')}
      onMouseLeave={() => onHide('kitchen')}
      className="text-xl text-brand-text cursor-pointer px-2 py-1"
    ><Link className="no-underline text-brand-text hover:text-brand-text" to="/my-kitchen/" onClick={() => onPageChanged('kitchen')}><span className="font-extrabold">my</span><span className="text-brand font-extrabold">Kitchen</span></Link>
      <div id="kitchen-menu" className="p-0 rounded absolute left w-40 -z-2 bg-zinc-500 flex-col hidden top-9 left-0">
        <div className="hover:bg-brand-hover p-0 text-left ">
          <Link
            to="/my-kitchen/"
            className="p-2 text-brand-text no-underline hover:text-brand-text"
            onClick={() => onPageChanged('kitchen')}
          >
            <span className="font-extrabold">my</span><span className="text-brand font-extrabold">Chefs</span>
          </Link>
        </div>
        {config.IS_MINT_ACTIVE ?
          <div className="hover:bg-brand-hover p-0 text-left ">
            <Link
              to="/mint/"
              className="p-2 text-brand-text no-underline hover:text-brand-text"
              onClick={() => onPageChanged('kitchen')}
            >
              Mint
            </Link>
          </div>
          : null}
        {
          config.IS_STAKING_ACTIVE ?
          <div className="hover:bg-brand-hover p-0 text-left ">
            <Link
              to="/staking/"
              className="p-2 text-brand-text no-underline hover:text-brand-text"
              onClick={() => onPageChanged('staking')}
            >
              Staking
            </Link>
          </div>
          : null
        }
        {
          config.IS_SUPER_OG_ACTIVE ?
              <div className="hover:bg-brand-hover p-0 text-left ">
                <Link
                    to="/super-og/0/-1/-1/"
                    className="p-2 text-brand-text no-underline hover:text-brand-text"
                    onClick={() => onPageChanged('super-og')}
                >
                  <span className="text-brand font-extrabold">Super</span>OG
                </Link>
              </div>
              : null
        }
      </div>
      <div id="kitchen-menu-bar" className={'h-0.5 bg-brand ' + getPageStyle('kitchen')}/>
    </button>
  </div>;
  const rafflesMenu = !config.IS_RAFFLES_ACTIVE ? null : <div className="relative sticky shadow-white">
    <button
        onMouseEnter={() => onShow('raffles')}
        onMouseLeave={() => onHide('raffles')}
        className="text-xl text-brand-text cursor-pointer px-2 py-1"
    >
      <a className="no-underline text-brand-text hover:text-brand-text" href="https://raffles.metakitchen.io/" onClick={() => onPageChanged('raffles')}>Raffles</a>
      <div id="raffles-menu-bar" className={'h-0.5 bg-brand ' + getPageStyle('raffles')}/>
    </button>
  </div>;
  return (
    <nav className="bg-black sticky top-0 mk-front">
      <div className="md:max-w-5xl mx-auto px-4">
        <div className="flex justify-between">
          <div className="flex items-center space-x-4 cursor-pointer">
            <Link
                to="/home/"
                className="no-underline text-brand-text hover:text-brand-text"
                onClick={() => {
                    resetHamburgerMenu();
                  }
                }
            >
              <img
                  className="w-16 md:w-32 lg:w-16"
                  alt="metaKitchen home page"
                  src={logo}
              />
            </Link>
            <div className="md:hidden flex justify-left space-x-1 text-brand-text ">
              <Hamburger toggled={isOpen} toggle={onToggleHamburgerMenu} />
            </div>
            <div className="hidden md:flex items-center space-x-1 text-brand-text">
              {homeMenu}
              {gameMenu}
              {collectionsMenu}
              {teamMenu}
              {papersMenu}
              {kitchenMenu}
              {rafflesMenu}
            </div>
          </div>
          <div className="flex items-center text-brand-text space-x-1">
            <div onClick={() => {
              window.open('https://discord.gg/metakitchen')
            }}>
              <img
                className="social-logo m-2 cursor-pointer"
                alt="metaKitchen Discord connection link"
                src={discordLogo}
              />
            </div>
            <div>
              <a href="https://twitter.com/meta_Kitchen">
                <img
                  className="social-logo m-2"
                  alt="metaKitchen Twitter feed"
                  src={twitterLogo}
                />
              </a>
            </div>
            <div className="">
              <a href="https://instagram.com/metakitchennft">
                <img
                  className="social-logo m-2"
                  alt="metaKitchen Instagram page"
                  src={instagramLogo}
                />
              </a>
            </div>
            <span>&nbsp;</span>
            <WalletMultiButton
              className="btn btn-primary m-1 w-24"
              startIcon={null}
            >
              {(!wallet || !base58) ? <div className="font-extrabold text-1x2">Connect</div> : base58.slice(0, 4) + '..' + base58.slice(-4)}
            </WalletMultiButton>
          </div>
        </div>
      </div>
      <div id="hamburgerMenu" className="sticky-top hidden md:hidden flex flex-col items-align-left rounded p-1 w-48 space-y-1 text-brand-text bg-zinc-500">
        {homeMenu}
        {gameMenu}
        {collectionsMenu}
        {teamMenu}
        {papersMenu}
        {kitchenMenu}
        {
          config.IS_SUPER_OG_ACTIVE ?
              <div className="hover:bg-brand-hover p-0 text-left ">
                <Link
                    to="/super-og/0/-1/"
                    className="p-2 text-xl text-brand-text no-underline hover:text-brand-text"
                    onClick={() => onPageChanged('super-og')}
                >
                  <span className="text-brand font-extrabold">Super</span>OG
                </Link>
              </div>
              : null
        }
        {rafflesMenu}
        {
          config.IS_STAKING_ACTIVE ?
              <div className="hover:bg-brand-hover p-0 text-left ">
                <Link
                    to="/staking/"
                    className="p-2 text-brand-text no-underline hover:text-brand-text text-xl"
                    onClick={() => onPageChanged('staking')}
                >
                  Staking
                </Link>
              </div>
              : null
        }
      </div>
    </nav>
  );

}

export default TWNavbar;
